import { Dialog, DialogContent, Grid } from "@material-ui/core";
import * as React from "react";
import { useState } from "react";
import { Button, SelectInput, useNotify, useRefresh } from "react-admin";
import { useAppDataProvider } from "../../../src/dataprovider";
import * as YearList from "../../Constants/YearList";
import { PeriodMonths } from "../../Constants/Constant";
import { Form } from "react-final-form";
import { ThumbDownAlt, ThumbUpAlt } from "@material-ui/icons";
import { AircraftUtilizationBulkApproveModel } from "./Constant/AircraftUtilizationModels";
import { AircraftUtilizationStatus } from "../../../src/Enums/AircraftUtilizationStatus";

export const AircraftUtilizationApproveBulk = props => {
  const [open, setOpen] = React.useState(props.open);
  const dataProvider = useAppDataProvider();
  const [selectedCustomer, setSelectedCustomer] = useState(0 as any);
  const [customerList, setCustomerList] = useState([] as any);
  const refresh = useRefresh();
  const notify = useNotify();

  React.useEffect(() => {
    setOpen(props.open);
  }, [props.open]);

  const handleClose = () => {
    setOpen(false);
    props?.handleClose?.();
  };

  const GetCustomerList = async () => {
    dataProvider
      .getList("customers/", {
        pagination: { page: 1, perPage: 9999 },
        sort: { field: "id", order: "DESC" },
        filter: {},
      })
      .then(response => {
        let dataLength: number = response.data.length;
        setCustomerList([]);
        if (dataLength > 0) {
          let data = response.data;
          setCustomerList(data);
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  React.useEffect(() => {
    GetCustomerList();
  }, []);

  const customerChangeEvent = e => {
    setSelectedCustomer(e.target.value);
  };

  const acceptClick = values => e => {
    let model: AircraftUtilizationBulkApproveModel = new AircraftUtilizationBulkApproveModel();
    model.OwnerCode = values.ownerCode;
    model.PeriodMonth = values.periodMonth;
    model.PeriodYear = values.periodYear;
    model.Status = AircraftUtilizationStatus.Accepted;
    SendBulkApprove(model);
  };

  const rejectClick = values => e => {
    let model: AircraftUtilizationBulkApproveModel = new AircraftUtilizationBulkApproveModel();
    model.OwnerCode = values.ownerCode;
    model.PeriodMonth = values.periodMonth;
    model.PeriodYear = values.periodYear;
    model.Status = AircraftUtilizationStatus.Rejected;
    SendBulkApprove(model);
  };

  const SendBulkApprove = final_data => {
    dataProvider
      .AircraftUtilizationBulkApprove(final_data)
      .then(result => {
        if (result.data == true) {
          notify(`Record Updated`, "success", false, true);
        } else {
          notify(`Please Enter Valid Data! Records cannot be updated!`, "error", false, true);
        }

        refresh();
      })
      .catch(error => notify(`${error}`, "error", false, true));
  };

  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={open}
        onClose={handleClose}
        aria-labelledby="max-width-dialog-title"
      >
        <DialogContent>
          <Form
            onSubmit={() => {}}
            render={({ handleSubmit, form, values }) => {
              return (
                <form>
                  <SelectInput
                    source="ownerCode"
                    choices={customerList}
                    optionText="customerName"
                    optionValue="ownerCode"
                    label="CUSTOMER"
                    onChange={customerChangeEvent}
                    fullWidth
                  ></SelectInput>
                  <SelectInput
                    source="periodYear"
                    choices={YearList.default}
                    optionText="key"
                    optionValue="key"
                    required
                    fullWidth
                  ></SelectInput>
                  <SelectInput
                    source="periodMonth"
                    choices={PeriodMonths}
                    optionText="month"
                    optionValue="value"
                    required
                    fullWidth
                  ></SelectInput>
                  <Grid container justifyContent={"flex-start"}>
                    <Grid item xs={3}>
                      <Button
                        size="medium"
                        label="Approve"
                        variant="contained"
                        color="primary"
                        onClick={acceptClick(values)}
                        style={{ margin: "8px", background: "#008000" }}
                      >
                        <ThumbUpAlt />
                      </Button>
                    </Grid>
                    <Grid item xs={3}>
                      <Button
                        size="medium"
                        label="Reject"
                        variant="contained"
                        color="primary"
                        onClick={rejectClick(values)}
                        style={{ margin: "8px", background: "#FF0000" }}
                      >
                        <ThumbDownAlt />
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              );
            }}
          />
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default AircraftUtilizationApproveBulk;
